import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-[#F5F1E8]">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link
            to="/"
            className="inline-flex items-center text-[#2C5F7C] hover:text-[#1e4a63] transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-[#2C5F7C] mb-8">
          Datenschutzerklärung
        </h1>

        <div className="bg-white rounded-lg shadow-md p-8 space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              1. Datenschutz auf einen Blick
            </h2>
            <h3 className="text-xl font-semibold text-gray-800 mb-3">
              Allgemeine Hinweise
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was
              mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
              besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können. Ausführliche Informationen zum
              Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten
              Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              2. Verantwortliche Stelle
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser
              Website ist:
            </p>
            <p className="text-gray-700 leading-relaxed">
              <strong>Wahr Privatinstitut für Dialog und Markenkompetenz UG</strong>
              <br />
              Nicolas Alexander Wahr
              <br />
              Mittelstraße 11
              <br />
              40789 Monheim am Rhein
              <br />
              <br />
              Telefon: 0174 6429886
              <br />
              E-Mail:{" "}
              <a
                href="mailto:Nicolas.wahr@icloud.com"
                className="text-[#87CEEB] hover:underline"
              >
                Nicolas.wahr@icloud.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              3. Datenerfassung auf dieser Website
            </h2>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">
              Kontaktformular
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
              Angaben aus dem Anfrageformular inklusive der von Ihnen dort
              angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den
              Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir
              nicht ohne Ihre Einwilligung weiter.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Erfasste Daten:</strong>
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-1">
              <li>Name</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer</li>
              <li>Nachrichtentext</li>
              <li>Zeitstempel der Anfrage</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO
              (Einwilligung)
              <br />
              <strong>Speicherdauer:</strong> Die Daten werden gelöscht, sobald sie
              für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich
              sind.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">
              Calendly (Terminbuchung)
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Auf unserer Website ist eine Terminbuchungsfunktion von Calendly
              eingebunden. Calendly ist ein Dienst der Calendly LLC, 271 17th St NW,
              10th Floor, Atlanta, Georgia 30363, USA.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Wenn Sie einen Termin über Calendly buchen, werden Ihre Daten
              (Name, E-Mail-Adresse, ggf. Telefonnummer) direkt an Calendly
              übermittelt und dort gespeichert. Die Verarbeitung erfolgt auf
              Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Weitere Informationen finden Sie in der Datenschutzerklärung von
              Calendly:{" "}
              <a
                href="https://calendly.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#87CEEB] hover:underline"
              >
                https://calendly.com/privacy
              </a>
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-6">
              PostHog (Analyse-Tool)
            </h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Diese Website nutzt PostHog, ein Analyse-Tool zur Verbesserung der
              Nutzererfahrung. PostHog erfasst anonymisierte Nutzungsdaten wie
              Seitenaufrufe, Klicks und Browserdaten.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO
              (berechtigtes Interesse an der Analyse und Optimierung unserer
              Website)
              <br />
              <strong>Anbieter:</strong> PostHog Inc., USA
              <br />
              <strong>Datenübertragung in Drittländer:</strong> PostHog verarbeitet
              Daten in den USA. Es besteht ein angemessenes Datenschutzniveau durch
              Standardvertragsklauseln.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Weitere Informationen:{" "}
              <a
                href="https://posthog.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#87CEEB] hover:underline"
              >
                https://posthog.com/privacy
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              4. Cookies
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die
              auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert.
              Sie richten keinen Schaden an.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese
              löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch
              wiederzuerkennen.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen von
              Cookies informiert werden und Cookies nur im Einzelfall erlauben, die
              Annahme von Cookies für bestimmte Fälle oder generell ausschließen
              sowie das automatische Löschen der Cookies beim Schließen des Browsers
              aktivieren.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              5. Ihre Rechte
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Sie haben jederzeit das Recht:
            </p>
            <ul className="list-disc list-inside text-gray-700 mb-4 space-y-2">
              <li>
                gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten
                personenbezogenen Daten zu verlangen
              </li>
              <li>
                gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder
                Vervollständigung Ihrer bei uns gespeicherten personenbezogenen
                Daten zu verlangen
              </li>
              <li>
                gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten
                personenbezogenen Daten zu verlangen
              </li>
              <li>
                gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer
                personenbezogenen Daten zu verlangen
              </li>
              <li>
                gemäß Art. 20 DSGVO Ihre personenbezogenen Daten in einem
                strukturierten, gängigen und maschinenlesbaren Format zu erhalten
                oder die Übermittlung an einen anderen Verantwortlichen zu verlangen
              </li>
              <li>
                gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung
                jederzeit gegenüber uns zu widerrufen
              </li>
              <li>
                gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              6. Widerspruchsrecht
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten
              Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO verarbeitet werden,
              haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die
              Verarbeitung Ihrer personenbezogenen Daten einzulegen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              7. Datensicherheit
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Wir verwenden innerhalb des Website-Besuchs das verbreitete
              SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils
              höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt
              wird. Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt
              übertragen wird, erkennen Sie an der geschlossenen Darstellung des
              Schlosssymbols in der Statusleiste Ihres Browsers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#2C5F7C] mb-4">
              8. Aktualität und Änderung dieser Datenschutzerklärung
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Diese Datenschutzerklärung ist aktuell gültig und hat den Stand
              Dezember 2024. Durch die Weiterentwicklung unserer Website oder
              aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es
              notwendig werden, diese Datenschutzerklärung zu ändern.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
